/**
 * 获取URL参数
 * example getUrlParam('id') or getUrlParam('id','url')
 */
exports.getUrlParam = function(name,url){
    var thatUrl = arguments[1] || window.location.href;
    var u = thatUrl.split("?"), StrBack = '';
    if (u.length > 1) {
        var gg = u[1].split("&");
        var MaxI = gg.length;
        var str = arguments[0] + "=";
        for (var i = 0; i < MaxI; i++) {
            if (gg[i].indexOf(str) == 0) {
                StrBack = gg[i].replace(str, "").replace(/#/g, "");
                StrBack = StrBack.split("#")[0];
                break;
            }
        }
    }
    return StrBack;
};

/**
 * 获取本页的itemid
 * 入参如果是itemid 建议以字符串传入，否则可能丢失精度
 * example getUrlParam(skuid) or getUrlParam(itemid)
 */
exports.getUrlItemid = function(skuid){
    var fsid = exports.getUrlParam('fsid');
    var u, params, StrBack = '';
    if(('' + skuid).length > 16){
        skuid = ('' + skuid).substr(16);
    }
    return '' + fsid + skuid;
};

//修改URL参数，parms：参数名，parmsValue：参数值，return：修改后的URL
exports.updateParms = function(parms, parmsValue,url) {
  var newUrlParms = "";
  var url =   arguments[2] || location.href;
  var newUrlBase = url.substring(0, url.indexOf("?") + 1); //截取查询字符串前面的url
  var query = url.split('?')[1]; //获取查询串
  if(!query){
    return url + '?' + parms + '=' + parmsValue;
  }
  var pairs = query.split("&"); //在逗号处断开
  var flag = 0; //标识是否找到
  for (var i = 0; i < pairs.length; i++) {
      var pos = pairs[i].indexOf('='); //查找name=value
      if (pos == -1) continue; //如果没有找到就跳过
      var argname = pairs[i].substring(0, pos); //提取name
      var value = pairs[i].substring(pos + 1); //提取value
      //如果找到了要修改的参数
      if (findText(argname, parms)) {
            flag = 1;
          newUrlParms = newUrlParms + (argname + "=" + parmsValue + "&");
      }
      else {
          newUrlParms += (argname + "=" + value + "&");
      }
  }
  //如果最后还是没找到参数则添加参数值
  if(flag == 0){
    return url + '&' + parms + '=' + parmsValue;
  }else{
    return newUrlBase + newUrlParms.substring(0, newUrlParms.length - 1);
  }

}

//辅助方法
var findText = function(urlString, keyWord) {
  return urlString.toLowerCase().indexOf(keyWord.toLowerCase()) != -1 ? true : false;
}




exports.updateUrl = function(url){
	var curUrl = location.href,
		newUrl = '';

	//如果当前页面链接上有fsid
	if(exports.getUrlParam('fsid') !== ''){
		var curFsid = exports.getUrlParam('fsid');
		var curVersion = curFsid.slice(0,2);
		var curSellerId = curFsid.slice(2,9);
		var curDisId = curFsid.slice(9,16);
	}else{
		//TODO:待定：如果当前页面链接上没有fsid，则填官微默认分销员的fsid
		var curFsid = '1002887510100510';
		var curVersion = '10';
		var curSellerId = '0288751';
		var curDisId = '0100510';
	}

	//传入的链接里有itemid
	if(exports.getUrlParam('itemid',url) !== '' ){
		var itemid = exports.getUrlParam('itemid',url);
		var disSkuId = itemid.slice(16);
		var newItemId = curVersion + curSellerId + curDisId + disSkuId;
		newUrl = exports.updateParms('itemid',newItemId,url);
	}else{
		//如果传入的链接里没有itemid，则看改链接是否是商祥链接，如果是商祥链接则取id作为skuid
		if( url.indexOf('detail') > -1 && exports.getUrlParam('id',url) !== '' ){
			var disSkuId = exports.getUrlParam('id',url);
			var newItemId = curVersion + curSellerId + curDisId + disSkuId;
			newUrl = exports.updateParms('itemid',newItemId,url);
		}else{
			//如果不是商祥的链接，则直接替换或加上fsid
			newUrl = exports.updateParms('fsid',curFsid,url);
		}
	}

	if(newUrl !== ''){
		url = newUrl;
	}

	//传入的链接是否有fsid，则替换fsid
	if(exports.getUrlParam('fsid',url) !== '' ){
		newUrl = exports.updateParms('fsid',curFsid,url);
	}

	return newUrl;

}

exports.throttle =  function(method,context){
	clearTimeout(method.tId);
	method.tId=setTimeout(function(){method.call(context)},200);
}

exports.getGoodsData = function(goodsIds,func){

  $.ajax({
      type: 'get',
      async: false,
      url: '//event.midea.cn/promote/w/mabapp/get_dis_sku_by_ids?ids=' + goodsIds.toString(),
      dataType: "jsonp",
      jsonp: "callback",//传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
      success: function(data){
          //渲染商品数据

          func(data.data);

      },
      error: function(){

      } 
  });
}
exports.getGoodsActData = function(data,func){
    $.ajax({
        url:'//event.midea.cn/promote/w/mabapp/get_dis_sku_act_info',
        async:false,
        data:data,
        dataType:"jsonp",
        jsonp:"callback",
        success:function(res){
            func(res);
        }

    });
}

exports.getPoolsData = function(poolId,pollLen,fsid,shopType,proPrice,func,extraData){
  console.log(fsid);
  if(fsid){
    var fsidStr = '&fsid=' + fsid;
  }else{
    var fsidStr = '';
  }

  $.ajax({
      type: 'get',
      async: false,
      url: '//event.midea.cn/promote/w/mabapp/get_pool?id=' + poolId + '&length=' + pollLen + '&shop_type=' + shopType + '&proprice=' + proPrice + fsidStr + '&tao_id_type=' + (extraData &&　extraData.taoIdType ? extraData.taoIdType : ''),
      dataType: "jsonp",
      jsonp: "callback",//传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
      success: function(data){
          if(data.errcode === 0){
            func(data.data);
          }

      },
      error: function(){

      }
  });
}
//获取秒杀列表
exports.getMiaoPoolsData=function(params,fsid,func){
    var miaoShaGoodsHtml='';
    if(fsid){
        var fsidStr = '?fsid=' + fsid;
    }else{
        var fsidStr = '?fsid=1000000000100511';
    }
    $.ajax({
        type: 'get',
        url: '//event.midea.cn/promote/w/mabapp/get_miao_goods'+fsidStr,
        data:params,
        dataType:'jsonp',
        jsonp: 'callback',
        success: function(data){
            //这里在php 中又进行处理
            miaoShaGoodsHtml =data.miaoShaGoodsHtml;
            func(miaoShaGoodsHtml);
        },
        error:function(){

        },
        complete: function(){
            return miaoShaGoodsHtml;
        }
    });
}
exports.timestampToTime = function(timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() + ' ';
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    return Y + M + D + h + m + s;
}


// WEBPACK FOOTER //
// ./module/func.js